import { createSelector } from 'reselect';

import getCartItems from './getCartItems';

const radix = 10;
const getCartItemInEditionFromShop = createSelector(
  getCartItems,
  (s, params) => params.productId,
  (items, productId) =>
    productId && items
      ? items.find(x => x.product === parseInt(productId, radix))
      : null,
);

export default getCartItemInEditionFromShop;
